import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { SupportTicketThread } from '@/components/support/SupportTicketShared';

export function SupportTicketDetailPage() {
  const { ticketId } = useParams<{ ticketId: string }>();
  const parsedTicketId = Number(ticketId);

  if (!Number.isFinite(parsedTicketId) || parsedTicketId <= 0) {
    return (
      <div className="mx-auto max-w-5xl space-y-6 px-6 py-6 md:px-8 lg:px-10">
        <PageHeader
          title="Support Ticket"
          subtitle="The requested ticket could not be opened."
        />
        <Link
          to="/help"
          className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          <ArrowLeft className="h-4 w-4" />
          Return to Help Center
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl space-y-6 px-6 py-6 md:px-8 lg:px-10">
      <div className="space-y-3">
        <Link
          to="/help"
          className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          <ArrowLeft className="h-4 w-4" />
          Return to Help Center
        </Link>
        <PageHeader
          title="Support Ticket"
          subtitle="Review the ticket conversation, download attachments, and send replies from the Help Center workflow."
        />
      </div>

      <SupportTicketThread ticketId={parsedTicketId} managerView={false} />
    </div>
  );
}
